import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import comingSoon from './media/coming-soon.6.mp4'
import { pageVisited } from '../../utils'
import {
  Root,
  VideoContainerWrapper,
  VideoContainer,
  Video,
  TVClusterAButton,
  TVClusterBButton,
} from './styles'

const Home = () => {
  const navigate = useNavigate()
  const [clusterAClickCount, setClusterAClickCount] = useState<number>(0)

  const handleTVClusterA = () => {
    setClusterAClickCount(clusterAClickCount + 1)
    if (clusterAClickCount >= 3 || pageVisited('cluster-a')) {
      navigate('/cluster-a')
    }
  }

  const handleTVClusterB = () => {
    alert('cluster B')
  }

  return (
    <Root>
      <VideoContainerWrapper>
        <VideoContainer>
          <TVClusterAButton
            onClick={() => handleTVClusterA()}
          ></TVClusterAButton>
          <TVClusterBButton onClick={handleTVClusterB}></TVClusterBButton>
          <Video autoPlay loop muted playsInline>
            <source src={comingSoon} type="video/mp4" />
            Your browser does not support the video tag!
          </Video>
        </VideoContainer>
      </VideoContainerWrapper>
    </Root>
  )
}

export default Home
